import { MediaResolution, MediaResolutions } from '@/redux/slices/slice_types';

export const MEDIA_INFO_TYPES: string[] = ['.mov', '.mp4', '.srt', '.wav', '.mpg', '.webp']; // took directly from BE BaseS3MediaInfoAPI

export const MediaResolutionsList: MediaResolution[] = [
  {
    name: MediaResolutions['4k'],
    value: MediaResolutions['4k'],
    resolution: []
  },
  {
    name: MediaResolutions.FHD,
    value: MediaResolutions.FHD,
    resolution: []
  },
  {
    name: MediaResolutions.HD,
    value: MediaResolutions.HD,
    resolution: []
  },
  {
    name: MediaResolutions.SD,
    value: MediaResolutions.SD,
    resolution: []
  }
];
